import React from 'react';

const Footer = ({ sidebarOpen }) => {
  return (
    <footer
      className="bg-white border-top mt-auto"
      style={{
        marginLeft: sidebarOpen ? '250px' : '0',
        transition: 'margin-left 0.3s ease-in-out'
      }}
    >
      <div className="container-fluid px-4 py-3">
        <div className="row align-items-center">
          <div className="col-md-6 mb-2 mb-md-0">
            
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-md-end gap-4">
              <a href="/privacy-policy" className="text-muted text-decoration-none small">Privacy Policy</a>
              <a href="/eula" className="text-muted text-decoration-none small">EULA</a>
             
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
